export const NOTIFICATIONS_MESSAGE_TYPES = {
    AB_TEST: 'ab_test',
    ACADEMY: 'academy',
    ACCOUNT_UPDATES: 'account_updates',
    ACHIEVEMENT: 'achievement',
    ALERT: 'alert',
    APPSFLYER_LOG: 'appsflyer_log',
    APP_LOG: 'app_log',
    AUTH: 'auth',
    BANNER: 'banner',
    DEMO_LIMITS: 'demo_limits',
    DEPOSIT: 'deposit',
    HINTS: 'hints',
    LEADERBOARD: 'leaderboard',
    MARKET: 'market',
    POSITION: 'position',
    PROMOCODE: 'promocode',
    REQUEST_FEEDBACK: 'request-feedback',
    RESPAWN_MOTIVATION: 'respawn_motivation',
    REFERRAL: 'referral',
    SOCKET: 'socket',
    SUBSCRIBE: 'subscribe',
    TUTORIALS: 'tutorials',
    UNSUBSCRIBE: 'unsubscribe',
    USER_PARAMS_UPDATE: 'user_params_update',
    USER_STATE_INFORMATION: 'user_state_information',
    USER_STATUS_UPDATE: 'user_status_update',
    VERIFY: 'verify',
    WITHDRAWAL: 'withdrawal',
} as const;

export const NOTIFICATION_MESSAGE_PROMOCODE_EVENTS = {
    ADD_PROMOCODE: 'add_promocode',
} as const;

export const NOTIFICATION_MESSAGE_TUTORIALS_EVENTS = {
    TUTORIAL_CREATED: 'tutorial_created',
    TUTORIAL_UPDATED: 'tutorial_updated',
    TUTORIAL_DELETED: 'tutorial_deleted',
    POSITIONS_UPDATED: 'positions_updated',
} as const;

export const NOTIFICATION_MESSAGE_AUTH_EVENTS = {
    LOGIN: 'login',
    LOGOUT: 'logout',
} as const;

export const NOTIFICATION_SUBSCRIBE_TYPES = {
    ACCOUNT_PL: 'account_pl',
} as const;

export const NOTIFICATION_MESSAGE_AB_TESTS_EVENTS = {
    USE_AB_TEST: 'use_ab_test',
} as const;

export const NOTIFICATION_MESSAGE_BANNER_EVENTS = {
    UPDATE_PARAMS: 'update_params',
} as const;

export const NOTIFICATION_MESSAGE_ALERT_EVENTS = {
    TRIGGERED_ALERT: 'triggered_alert'
} as const;

export const NOTIFICATION_MESSAGE_POSITION_EVENTS = {
    CLOSED_POSITION: 'closed_position',
} as const;

export const NOTIFICATION_MESSAGE_MARKET_EVENTS = {
    COLLECTION_UPDATED: 'collection_updated',
    VIEW_ASSET: 'view_asset',
} as const;

export const NOTIFICATION_MESSAGE_HINT_EVENTS = {
    GET_USER_HINTS: 'get_user_hints',
    ADD_USER_HINT: 'add_user_hint',
} as const;

export const NOTIFICATION_MESSAGE_DEMO_LIMITS_EVENTS = {
    GET_ORDERS_LEFT: 'get_orders_left',
    ORDER_COMMITED: 'order_commited',
} as const;

export const NOTIFICATION_MESSAGE_REFERRAL_EVENTS = {
    RECEIVED_REWARD: 'received-reward',
} as const;

export const NOTIFICATION_MESSAGE_ACADEMY_EVENTS = {
    STEP_COMPLETED: 'step_completed',
    UPDATE_USER_ACADEMY_LESSON: 'update_user_academy_lesson',
} as const;

export const NOTIFICATION_MESSAGE_LEADERBOARD_EVENTS = {
    ONBOARDING_PASSED: 'onboarding_passed',
    LEAGUE_PARAMS_UPDATED: 'league_params_updated',
} as const;